import { Megaphone } from "lucide-react";
import { useWebConfig } from "@/hooks/useWebConfig";

/** Site-wide announcement bar driven live by `config/web`.banner — the Web
 *  Config page's flag/banner writes show up here for every signed-in user. */
export function MaintenanceBanner() {
  const { banner } = useWebConfig();

  if (!banner.enabled || !banner.message) return null;

  return (
    <div
      role="status"
      data-testid="maintenance-banner"
      className="flex items-center justify-center gap-2 bg-amber-100 px-4 py-2 text-sm font-medium text-amber-900 dark:bg-amber-900 dark:text-amber-100"
    >
      <Megaphone className="h-4 w-4 shrink-0" />
      <span>{banner.message}</span>
    </div>
  );
}
